module.exports = __webpack_public_path__ + "img/student-start.f9e05b8b.png";